import { LookupDataEnums } from '../../utilities/Constants';
import { useQuery } from 'react-query';
import { useZoneContext } from '../../contexts/useZoneContext';

export const useGetNoteCategoryTypes = (type?: LookupDataEnums) => {
    const { zoneApiClient } = useZoneContext();
    return useQuery({
        queryKey: ['get-note-category-types'],
        queryFn: async () => {
            const response = await zoneApiClient.getNoteCategoryTypes(type);

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve note category types.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
        staleTime: Infinity,
        cacheTime: Infinity,
    });
};
